/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 16.10.13
 * Time: 17:50
 * To change this template use File | Settings | File Templates.
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class ShopLoadedTrackingEvent extends BasicTrackingEvent {
    public playerId: number;
    public date: number;
    public sessionId: string;
    public microtime: string;

    public shopId: number;
    public storeId: number;
    public deviceId: number;
    public connectionType: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};

        vars.playerId = this.playerId;
        vars.date = this.date;
        vars.var_1 = this.sessionId;
        vars.var_2 = this.microtime;
        vars.var_3 = this.shopId;
        vars.var_4 = this.storeId;
        vars.var_5 = this.deviceId;
        vars.var_data = [];
        vars.var_data[0] = this.connectionType;

        return vars;
    }
}
